<div class="auth-container">
    <form [formGroup]="form" (ngSubmit)="submit()">
        <mat-form-field appearance="fill">
            <mat-label>Contraseña</mat-label>
            <input matInput type="password" formControlName="password" />
        </mat-form-field>

        <div class="buttons">
            <button matButton="filled" type="submit">Entrar</button>
            <button matButton="outlined" (click)="exit()">Salir</button>
        </div>

        <div *ngIf="error" style="color: red; margin-top: 10px;">
            Datos incorrectos.
        </div>
    </form>
</div>